import FileSaver from 'file-saver';

const fileSaver = (fileData, fileName) => FileSaver.saveAs(fileData, fileName);

export default fileSaver;
